/**
 * PressReleaseItem
 * @module components/PressReleaseItem
 */

import PropTypes from 'prop-types';
import { Link, Text, ReleaseItemStyle } from './PressCalendariumBlock.styles';
import { useSiteType } from 'context/siteType.context';

const PressReleaseItem = ({ date, name, link }) => {
	const siteType = useSiteType();
	return (
		<ReleaseItemStyle>
			<Text isLindGroup={siteType === 'LindabGroup'}>{date}</Text>
			<Link isLindGroup={siteType === 'LindabGroup'} href={link}>
				{name}
			</Link>
		</ReleaseItemStyle>
	);
};

PressReleaseItem.propTypes = {
	date: PropTypes.string,
	name: PropTypes.string,
};

export default PressReleaseItem;
